export default {
  ACTIVE_POPUP(state, payload) {
    /*
		 	payload = {
				key: 'field',
				value: true || false
			}
		*/
    state[payload.key] = payload.value;
  },
  UPDATE_STATE(state, payload) {
    /*
		 	payload = {
				key: 'field',
				value: true || false
			}
		*/
    state[payload.key] = payload.value;
  },
  ADD_QUESTION(state, payload) {
    state.questionsByPage.push(payload);
  },
  DELETE_QUESTION(state, index) {
    state.questionsByPage.splice(index, 1);
  },
  CHANGE_QUESTION(state, payload) {
    state.questionsByPage.splice(payload.index, 1);
    state.questionsByPage.splice(payload.index, 0, payload.question);
  },
  CHANGE_DATA_SIDEBAR(state, payload) {
    const { nameForm, grupo, isSubForm, version, formID, companyID, companyName } = payload;
    state.dataSidebar.nameForm = nameForm;
    state.dataSidebar.grupo = grupo;
    state.dataSidebar.isSubForm = isSubForm;
    state.dataSidebar.version = version;
    state.dataSidebar.formID = formID;
    state.dataSidebar.companyID = companyID;
    state.dataSidebar.companyName = companyName;

  },
  CLEAR_DATA(state) {
    state.idForm = null;
    state.idPage = null;
    state.idCounter = null;
    state.idDependence = null;
    state.questionsByPage = [];
    state.allPages = [];
    state.counter = 0;
    state.actiePopupDependence = false;
    state.activePopupChoice = false;
    state.activePopupFlex = false;
    state.indexQuestionSetting = null;
    state.optionsDependencies = [];
    state.disabledGroup = false;
    state.dataSidebar = {
      nameForm: "",
      grupo: "",
      isSubForm: false
    };

    state.componentPopup = "";
    state.activePopup = false;
    state.indexQuestion = 0;
    state.listOrigins = [];
    state.listSubFormularios = [];
  },
  COPY_QUESTION(state, payload) {
    const { question, position } = payload;
    state.questionsByPage.splice(position + 1, 0, question);
    state.counter++;
  },
  RESET_DATA(state) {
    state.idForm = null;
    state.idPage = null;
    state.idCounter = null;
    state.idDependence = null;
    state.questionsByPage = [];
    state.allPages = [];
    state.counter = 0;
    state.actiePopupDependence = false;
    state.activePopupChoice = false;
    state.activePopupFlex = false;
    state.indexQuestionSetting = null;
    state.optionsDependencies = [];
    state.saveCreatedDependecies = {};
    state.AllQuestions = [];

    state.disabledGroup = false;
    state.dataSidebar = {
      nameForm: "",
      grupo: "",
      isSubForm: "0",
      version: 1
    };

    state.listSubFormularios = [];
    state.listOrigins = [];

    state.componentPopup = "";
    state.activePopup = false;
    state.indexQuestion = 0;

    state.clickNotClose = true;
    state.isFilterSidebarActive = true;
  }
};
